import React, { useContext } from "react";
import SingleProduct from "../../../../components/general/singleProduct/SingleProduct";
import MyContext from "../../../../contexts/AppContext";
import "../../../../assets/css/customer/subscreens/category/CategoryPage.css";

const ProductsGrid = ({ products }) => {
  const { baseUrlForFiles } = useContext(MyContext);

  return (
    <div className="products-grid">
      {products.map((product) => (
        <div key={product.id} className="product-card-wrapper">
          <SingleProduct product={product} />
        </div>
      ))}
    </div>
  );
};

export default ProductsGrid;